import React from "react";
import {
  Box,
  Flex,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { MdLocationOn } from "react-icons/md";
import { EnrichedSupplierForDelivery } from "../../types";
import { getVehicleTypeDisplay } from "../../utils/vehicleTypeUtils";

export interface SupplierSplitHeaderProps {
  displayTitle: string;
  supplier: EnrichedSupplierForDelivery;
  isRemainingItems: boolean;
  supplierFulfillingItemsMRP: number;
  actions: React.ReactNode;
}

export const SupplierSplitHeader: React.FC<SupplierSplitHeaderProps> = ({
  displayTitle,
  supplier,
  isRemainingItems,
  supplierFulfillingItemsMRP,
  actions,
}) => (
  <Box
    bg="gray.50"
    px={4}
    py={3}
    borderBottom="1px solid"
    borderColor="orange.200"
  >
    <Flex justify="space-between" align="center">
      <HStack spacing={3} align="flex-start">
        <VStack align="flex-start" spacing={0}>
          <Text
            fontSize="0.95rem"
            fontWeight="800"
            color="gray.700"
            fontFamily="'Nunito','Inter', sans-serif"
            textTransform="uppercase"
            letterSpacing="wide"
          >
            {displayTitle}
          </Text>
          {!isRemainingItems && supplier.supplierCity && (
            <HStack spacing={1}>
              <MdLocationOn size="12" color="#3b82f6" />
              <Text
                fontSize="0.75rem"
                color="gray.600"
                fontFamily="'Nunito','Inter', sans-serif"
                fontWeight="600"
              >
                {supplier.supplierCity}
              </Text>
            </HStack>
          )}
        </VStack>
        <HStack spacing={2} align="center">
          {!isRemainingItems && supplier.distanceKm !== undefined && (
            <HStack
              spacing={1}
              bg="white"
              px={2}
              py={0.5}
              borderRadius="full"
              border="1px solid"
              borderColor="gray.200"
            >
              <MdLocationOn size="12" color="#3b82f6" />
              <Text
                fontSize="0.7rem"
                color="gray.500"
                fontFamily="'Nunito','Inter', sans-serif"
                fontWeight="600"
              >
                {supplier.distanceKm.toFixed(1)} km
              </Text>
            </HStack>
          )}
          {!isRemainingItems && supplier.vehicleType !== undefined && (
            <HStack
              spacing={1}
              bg="white"
              px={2}
              py={0.5}
              borderRadius="full"
              border="1px solid"
              borderColor="gray.200"
            >
              <Text
                fontSize="0.7rem"
                color="gray.500"
                fontFamily="'Nunito','Inter', sans-serif"
                fontWeight="700"
              >
                {getVehicleTypeDisplay(supplier.vehicleType)?.label || ""}
              </Text>
              {getVehicleTypeDisplay(supplier.vehicleType)?.icon && (
                <Icon
                  as={getVehicleTypeDisplay(supplier.vehicleType)?.icon}
                  color="blue.500"
                  boxSize={3}
                />
              )}
            </HStack>
          )}
          <HStack
            spacing={1}
            bg="white"
            px={2}
            py={0.5}
            borderRadius="full"
            border="1px solid"
            borderColor="gray.200"
          >
            <Text
              fontSize="0.7rem"
              color="gray.500"
              fontFamily="'Nunito','Inter', sans-serif"
              fontWeight="700"
            >
              MRP: ₹{supplierFulfillingItemsMRP.toLocaleString("en-IN")}
            </Text>
          </HStack>
        </HStack>
      </HStack>
      {actions}
    </Flex>
  </Box>
);
